import React, { useEffect } from 'react';
import { defineMessages } from 'react-intl';
import { generatePath, useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import apiConfig from '@constants/apiConfig';
import useFetch from '@hooks/useFetch';
import useSaveBase from '@hooks/useSaveBase';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { showErrorMessage } from '@services/notifyService';

import routes from '../routes';

import InwenChildForm from './InwenChildForm';

const messages = defineMessages({
    objectName: 'INWENS',
});

const InwenChildSavePage = () => {
    const courseId = useParams();
    const queryParams = new URLSearchParams(location.search);
    const parentId = queryParams.get('parentId');
    const name = queryParams.get('name');
    const translate = useTranslate();
    const { detail, mixinFuncs, loading, setIsChangedFormValues, isEditing, title } = useSaveBase({
        apiConfig: {
            getById: apiConfig.inwen.getById,
            create: apiConfig.inwen.create,
            update: apiConfig.inwen.update,
        },
        options: {
            getListUrl: `${generatePath(routes.inwenChildListPage.path, { id: parentId })}?parentId=${parentId}&name=${name}`,
            objectName: translate.formatMessage(messages.objectName),
        },
        override: (funcs) => {
            funcs.prepareUpdateData = (data) => {
                return {
                    ...data,
                    id: detail.id,
                };
            };
            funcs.prepareCreateData = (data) => {
                return {
                    ...data,
                };
            };
            funcs.onSaveError = (err) => {
                mixinFuncs.handleShowErrorMessage(err, showErrorMessage);

                mixinFuncs.setSubmit(false);
            };
        },
    });

    return (
        <PageWrapper
            loading={loading}
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.MediaLibrary),
                    path: generatePath(routes.inwenListPage.path),
                },
                {
                    breadcrumbName: name,
                    path: `${generatePath(routes.inwenChildListPage.path, { id: parentId })}?parentId=${parentId}&name=${name}`,
                },
                { breadcrumbName: title },
            ]}
            title={title}
        >
            <InwenChildForm
                setIsChangedFormValues={setIsChangedFormValues}
                dataDetail={detail ? detail : {}}
                formId={mixinFuncs.getFormId()}
                isEditing={isEditing}
                actions={mixinFuncs.renderActions()}
                onSubmit={mixinFuncs.onSave}
            />
        </PageWrapper>
    );
};

export default InwenChildSavePage;
